export const CentralArizonaActionType = Object.freeze({
  TOGGLE_ABOUT: "Central Arizona:: Toggling the About Drawer",
  SET_CHART: "Central Arizona:: Set chart",
  SET_ENTITLEMENTS: "Central Arizona:: Set Entitlements",
  SET_SCENARIO: "Central Arizona:: Set Scenario",
  SET_PRIORITY_ENTITLEMENTS: "Central Arizona:: Set Priority Pool Entitlements",
  SET_ENTITLEMENT_DIFFERENCE:
    "Central Arizona:: Set Entitlement Difference for Each Entity (for Map coloring)",
});
